import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { OPEN_MODAL, CLOSE_MODAL, RESET_MODAL, ADD_MODAL_ITEM, ADD_MODAL_EXTRA, ADD_MODAL_WARRANTY, ADD_MODAL_CATEGORY, REMOVE_MODAL_WARRANTY, UPDATE_TROLLEY_META_EXTRAS, UPDATE_TROLLEY_META_CATEGORIES, FETCH_RECOMMENDATIONS_INITIATED, FETCH_RECOMMENDATIONS_COMPLETED, UPDATE_TROLLEY_SUCCEEDED, UPDATE_GO_TO_TROLLEY_ENABLED } from '../actions';
export var initialState = {
  openModal: false,
  addedItems: [],
  addedItemsAttributes: {},
  extraItems: [],
  extraItemsMeta: {},
  warrantyItems: [],
  isGoToTrolleyEnabled: true,
  categoryItems: [],
  categoryItemsMeta: {},
  fetchedRecommendationsItems: false,
  fetchedTrolleyItems: false,
  pendingRequestCount: -1
};
/**
 * Manage the trolley view and its state
 * @method modalReducer
 */

export var modalReducer = function modalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case OPEN_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        openModal: true
      });

    case CLOSE_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        openModal: false
      });

    case RESET_MODAL:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        openModal: state.openModal
      });

    case ADD_MODAL_ITEM:
      {
        var partNumber = action.partNumber,
            quantity = action.quantity;
        return _objectSpread(_objectSpread({}, state), {}, {
          addedItems: _toConsumableArray(new Set([].concat(_toConsumableArray(state.addedItems), [partNumber]))),
          addedItemsAttributes: _objectSpread(_objectSpread({}, state.addedItemsAttributes), {}, _defineProperty({}, partNumber, {
            quantity: quantity
          }))
        });
      }

    case ADD_MODAL_EXTRA:
      return _objectSpread(_objectSpread({}, state), {}, {
        extraItems: _toConsumableArray(new Set([].concat(_toConsumableArray(state.extraItems), [action.extra])))
      });

    case ADD_MODAL_WARRANTY:
      return _objectSpread(_objectSpread({}, state), {}, {
        warrantyItems: _toConsumableArray(new Set([].concat(_toConsumableArray(state.warrantyItems), [action.warranty])))
      });

    case REMOVE_MODAL_WARRANTY:
      return _objectSpread(_objectSpread({}, state), {}, {
        warrantyItems: [],
        hideWarranties: true
      });

    case ADD_MODAL_CATEGORY:
      return _objectSpread(_objectSpread({}, state), {}, {
        categoryItems: _toConsumableArray(new Set([].concat(_toConsumableArray(state.categoryItems), [action.category])))
      });

    case UPDATE_TROLLEY_META_EXTRAS:
      return _objectSpread(_objectSpread({}, state), {}, {
        extraItemsMeta: action.meta
      });

    case UPDATE_TROLLEY_META_CATEGORIES:
      return _objectSpread(_objectSpread({}, state), {}, {
        categoryItemsMeta: action.meta
      });

    case FETCH_RECOMMENDATIONS_INITIATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        pendingRequestCount: state.pendingRequestCount + 1
      });

    case FETCH_RECOMMENDATIONS_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchedRecommendationsItems: true,
        pendingRequestCount: state.pendingRequestCount - 1
      });

    case UPDATE_TROLLEY_SUCCEEDED:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchedTrolleyItems: true
      });

    case UPDATE_GO_TO_TROLLEY_ENABLED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isGoToTrolleyEnabled: action.payload
      });

    default:
      return state;
  }
};